import React from 'react'
import Kdivider from 'ui-shared/LayoutComponents/Kdivider'
import CustomReferenceInput from 'ui-shared/CustomInputs/CustomReferenceInput'
import LocalizedSelectInput from 'ui-shared/LocalizedFields/LocalizedSelectInput'
import MainProductForm, {
  MainProductFormProps,
} from 'ui-shared/Forms/MainProductForm'
import HighlightsInput from 'ui-shared/WrappedInputs/HighlightsInput'
import BookingTimeLimitInput from 'ui-shared/WrappedInputs/BookingTimeLimitInput'
import BeforeAfterHintForm from 'ui-shared/Hints/TimeBeforeAfterHint/BeforeAfterHintForm'
import QuantityHintForm from 'ui-shared/Hints/QuantityHint/QuantityHintForm'
import LinkedRulesPanel from 'ui-shared/LinkedRulesPanel'
import ProfessionalByRulePricingInput from 'ui-shared/FormComponents/pricing/byRules/ProfessionalByRulePricingInput'
import { yupResolver } from '@hookform/resolvers/yup'
import { professionalVS } from 'services/validations/catalog/professional'

type ProfessionalFigureFormProps = MainProductFormProps

const ProfessionalFiguresForm: React.FC<ProfessionalFigureFormProps> = (
  props
) => (
  <MainProductForm
    {...props}
    resolver={yupResolver(professionalVS)}
    disableTailoredValidation
  >
    <CustomReferenceInput entity="professionalsections">
      <LocalizedSelectInput
        source="section"
        label="Professional Section"
        fullWidth
      />
    </CustomReferenceInput>
    <BookingTimeLimitInput />
    <HighlightsInput />
    <ProfessionalByRulePricingInput />
    <Kdivider title="Suggestions" headingLevel="h1" />
    <QuantityHintForm
      accordionText={[
        'quantityProfessionalsHintAccordionText1',
        'quantityProfessionalsHintAccordionText2',
        'quantityProfessionalsHintAccordionText3',
        'quantityProfessionalsHintAccordionText4',
      ]}
    />
    <BeforeAfterHintForm
      accordionText={[
        'beforeAfterHintAccordionText1',
        'beforeAfterHintAccordionText2',
        'beforeAfterHintAccordionText3',
      ]}
    />
    <LinkedRulesPanel />
  </MainProductForm>
)

export default ProfessionalFiguresForm
